require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-what-types-of-content-are-most-important-for-e-commerce.json") })
        }
      }, "path---blog-what-types-of-content-are-most-important-for-e-commerce");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-what-types-of-content-are-most-important-for-e-commerce!./.cache/json/blog-what-types-of-content-are-most-important-for-e-commerce.json
// module id = 515
// module chunks = 231608221292675